import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { DeviceScheduledTasksStoreActions } from '../../../sub-features/device-sync/device-scheduled-tasks-store';
import { DeviceScheduledTasksCancelComponent } from './device-scheduled-tasks-cancel.component';

@Component({
  selector: 'era-device-scheduled-tasks-cancel',
  templateUrl: './device-scheduled-tasks-cancel.container.html',
  imports: [DeviceScheduledTasksCancelComponent],
})
export class DeviceScheduledTasksCancelContainerComponent {
  private readonly store = inject(Store);

  public cancel() {
    this.store.dispatch(DeviceScheduledTasksStoreActions.DeviceScheduledTasksUiActions.scheduledTasksDeleted());
  }
}
